import React, { useState, useEffect, useRef } from "react";
import config from "../config/config";
import styled from "styled-components";

import titolo from "../images/titolo_upload.png";

function Upload() {
  const [preview, setPreview] = useState(null);
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const maxReconnectAttempts = 3;
  const wsRef = useRef(null);
  
  
  
  
  
const ArticleColumns = styled.div`
	clear: both;
`;

const ClearDiv = styled.div`
	clear: both;
`;

const ArticleDescContainer = styled.div`
	width: 70%;
	padding: 5px;
	float: left;
`;
const ArticleImgContainer = styled.div`
	float: left;
	max-width: 80px;
    max-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
	
`;

const ArticleImg = styled.img`
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
	border: 1px solid #CCC;
	border-radius: 5px;
`;


const ArticleDiv = styled.div`
	border: 1px solid #ccc;
	border-radius: 5px;
	padding: 5px;
	margin: 3px auto;
	width: 90%;
	textAlign: center;
	background: rgba(230,230,230);
`;

const ArticleTitle = styled.h1`
	font-family: 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
	margin: 5px auto;
	font-size: 1em;
`;


const PriceDisclaimer = styled.p`
	margin: 5px auto;
	font-size: 0.7em;
`;

const ArticleDesc = styled.p`
	margin: 5px auto 10px auto;
	font-size: .8em;
`;

const ArticleNota = styled.p`
	margin: 5px auto 10px auto;
	font-size: .7em;
	font-style: italic;
`;

const ArticleNotActive = styled.p`
	margin: 5px auto 10px auto;
	font-size: .8em;
	color: #F00;
`;

const ArticleLink = styled.button`
  background-color: #F99; 
  color: #fff; 
  border: none;
  padding: 10px;
  margin: 0 5px;
  border-radius: 5px;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  font-size: 1em;
`;

function formatArticleLink(articolo) {
  return articolo ? articolo.replace(/\//g, '-') : ''; 
}



  useEffect(() => {
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  const compressAndResizeImage = (file, maxWidth = 2000, maxHeight = 2000, quality = 1) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          // Resize keeping aspect ratio
          if (width > maxWidth || height > maxHeight) {
            if (width > height) {
              height *= maxWidth / width;
              width = maxWidth;
            } else {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Convert to base64 with compression
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Compression failed"));
              }
            },
            "image/jpeg",
            quality
          );
        };
      };
    });
  };
const connectWebSocket = (client_id, imageBlob) => {
    if (wsRef.current) {
        wsRef.current.close(); // Close previous connection if exists
    }

    const url = `${config.WS_SERVER}/${client_id}`;
    console.log("Connecting to WebSocket:", url);

    const ws = new WebSocket(url);
    wsRef.current = ws;
    setLoading(true);

    ws.onopen = async () => {
      console.log("WebSocket opened");
      setReconnectAttempts(0);

      try {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Image = reader.result.split(",")[1];
          const data = JSON.stringify({ data: `data:image/jpeg;base64,${base64Image}` });

          ws.send(data);
          console.log("Compressed image sent to WebSocket");
        };
        reader.readAsDataURL(imageBlob);
      } catch (error) {
        console.error("Error sending image:", error);
        setLoading(false);
      }
    };

	ws.onmessage = (event) => {
	  console.log("Received WebSocket response");
	  try {
		const message = JSON.parse(event.data);
		console.log("Response:", message);

		// Flatten the array structure
		const formattedResults = Array.isArray(message) && Array.isArray(message[0])
		  ? message[0] // Extract first level if it contains a single nested array
		  : message;

		setResults(formattedResults);
	  } catch (error) {
		console.error("Error parsing message:", error);
		setResults([]);
	  }
	  ws.close();
	};

	
	
	
	
	
	
	
	
	

	ws.onerror = (error) => {
		console.error("WebSocket error:", error);
		ws.close();
		
		if (reconnectAttempts < maxReconnectAttempts) {
			setReconnectAttempts(prev => prev + 1);
			setTimeout(() => {
				console.log(`Reconnecting... Attempt ${reconnectAttempts + 1}`);
				connectWebSocket(client_id, imageBlob);
			}, 2000);
		} else {
			alert("WebSocket connection failed. Please try again later.");
		}
	};

    ws.onclose = () => {
      console.log("WebSocket closed");
      setLoading(false);
    };
  };

const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  setResults([]); // Clear previous results before starting a new upload

  const reader = new FileReader();
  reader.onloadend = async () => {
    setPreview(reader.result); // Set preview before compression

    try {
      const compressedBlob = await compressAndResizeImage(file);
      connectWebSocket(Date.now(), compressedBlob);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };
  reader.readAsDataURL(file);
};


  return (
    <div>
	  <h1>Upload</h1>
      <h2>Carica o scatta una foto</h2>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {preview && (
        <div style={{ display: 'none' }}>
          <h3>Preview:</h3>
          <img src={preview} alt="Selected" style={{ maxWidth: "20%", height: "auto" }} />
        </div>
      )}

     

	  
	  
		  

	  
{loading ? (
  <p>Sto processando l'immagine...</p> // While loading, show this message
) : results !== null ? (  // Only render the results section if results have been set (i.e. after a request)
  Array.isArray(results) && results.length > 0 ? (
    results.map((item, index) => (
      <ArticleDiv key={item.articolo}>
        {item.attivo === 'N' ? (
          <ArticleNotActive>
            {item.articolo}: ARTICOLO FUORI PRODUZIONE
          </ArticleNotActive>
        ) : (
          <>
            <ArticleTitle>{item.articolo}: {item.prezzoFormattato}</ArticleTitle>
			<PriceDisclaimer>Prezzo a rivenditore IVA esclusa</PriceDisclaimer>
            <ArticleColumns>
              <ArticleImgContainer>
                <ArticleImg 
                  src={
                    item.pathImmagini?.length > 0 
                      ? `https://b2b.artlineagioielli.it/archivi/${item.pathImmagini[0]}`
                      : "https://via.placeholder.com/80"
                  } 
                  alt={item.articolo} 
                />
              </ArticleImgContainer>
				<ArticleDescContainer>
				  <ArticleDesc>{item.descrizione}</ArticleDesc>
				  {item.tipoVendita === 'peso' && <ArticleNota />}
				  {item.permalink ? (
					<ArticleLink as="a" href={item.permalink}>
					  Dettagli
					</ArticleLink>
				  ) : (
					<ArticleLink as="a" href={`https://artlineagioielli.it/?s=${formatArticleLink(item.articolo)}#inizio-risultati`}>
					  Dettagli
					</ArticleLink>
				  )}
				</ArticleDescContainer>
              <ClearDiv />
            </ArticleColumns>
          </>
        )}
      </ArticleDiv>
    ))
  ) : (
    <p>Nessun risultato!</p>  // When results is an empty array (i.e. after a search returns nothing), show this message
  )
) : null}



	  
	  
	  
    </div>
  );
}

export default Upload;
